export default {
	TABLE_TITLE: 'Product recommendations',
	PRODUCT_RECOMMENDATION_ADDED: 'Product recommendation added.',
	PRODUCT_RECOMMENDATION_EDITED: 'Product recommendation edited.',
	PRODUCT_RECOMMENDATION_DELETED: 'Product recommendation deleted.'
};
